import { type TSocialMedia } from '@shared/ui'
import { useMemo } from 'react'

import useData from './query'

export default () => {
  const {
    site: {
      siteMetadata: {
        externalUrls: {
          bilibili: bilibiliUrl,
          bluesky: blueskyUrl,
          discord: discordUrl,
          facebook: facebookUrl,
          instagram: instagramUrl,
          linkedin: linkedinUrl,
          reddit: redditUrl,
          steam: steamUrl,
          substack: substackUrl,
          tiktok: tiktokUrl,
          x: xUrl,
          youtube: youtubeUrl,
        },
      },
    },
  } = useData()

  const links = useMemo<{ ariaLabel: TSocialMedia; to: string }[]>(
    () => [
      { ariaLabel: 'Steam', to: steamUrl },
      { ariaLabel: 'Discord', to: discordUrl },
      { ariaLabel: 'X', to: xUrl },
      { ariaLabel: 'Instagram', to: instagramUrl },
      { ariaLabel: 'YouTube', to: youtubeUrl },
      { ariaLabel: 'Facebook', to: facebookUrl },
      { ariaLabel: 'Reddit', to: redditUrl },
      { ariaLabel: 'TikTok', to: tiktokUrl },
      { ariaLabel: 'BlueSky', to: blueskyUrl },
      { ariaLabel: 'Substack', to: substackUrl },
      { ariaLabel: 'LinkedIn', to: linkedinUrl },
      { ariaLabel: 'Bilibili', to: bilibiliUrl },
    ],
    [
      bilibiliUrl,
      blueskyUrl,
      discordUrl,
      facebookUrl,
      instagramUrl,
      linkedinUrl,
      redditUrl,
      steamUrl,
      substackUrl,
      tiktokUrl,
      xUrl,
      youtubeUrl,
    ]
  )

  return links
}
